import React, { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertTriangle, CheckCircle2, Download, Eye, Loader2, Upload } from 'lucide-react';
import { getApiHeaders } from '../../utils/apiHelpers';
import { API_ARCHIVIO, urlScansione } from './archivioApi';

const AMBRA = 'bg-amber-500/15 text-amber-300 border-amber-500/30 lg:bg-amber-50 lg:text-amber-700 lg:border-amber-200';
const STATI = {
  pronta: { testo: 'Scansione pronta', Icona: CheckCircle2, cls: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30 lg:bg-emerald-50 lg:text-emerald-700 lg:border-emerald-200' },
  da_creare: { testo: 'In preparazione', Icona: Loader2, cls: 'bg-purple-500/15 text-purple-300 border-purple-500/30 lg:bg-purple-50 lg:text-purple-700 lg:border-purple-200', spin: true },
  mancante: { testo: 'Scansione mancante', Icona: AlertTriangle, cls: AMBRA },
  illeggibile: { testo: 'Scansione mancante', Icona: AlertTriangle, cls: AMBRA, nota: 'foto non leggibile' },
};

export const StatoScansione = ({ ddt }) => {
  const s = STATI[ddt.stato_scansione] || STATI.mancante;
  const pagine = ddt.scansione?.pagine > 1 ? ` · ${ddt.scansione.pagine} pag.` : '';
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium whitespace-nowrap ${s.cls}`}
      data-testid={`archivio-stato-${ddt.id}`}
      data-stato={ddt.stato_scansione}
      title={s.nota}
    >
      <s.Icona className={`h-3.5 w-3.5 ${s.spin ? 'animate-spin' : ''}`} />
      {s.testo}{pagine}{s.nota ? ` (${s.nota})` : ''}
    </span>
  );
};

const BTN = 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors active:scale-95';

export const AzioniScansione = ({ ddt, onAggiorna }) => {
  const input = useRef(null);
  const [invio, setInvio] = useState(false);

  const carica = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setInvio(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      await axios.post(`${API_ARCHIVIO}/${ddt.id}/scansione`, fd, { headers: getApiHeaders(), timeout: 120000 });
      toast.success('Scansione salvata in archivio');
      onAggiorna();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Caricamento non riuscito');
    } finally {
      setInvio(false);
    }
  };

  if (ddt.stato_scansione === 'pronta') {
    return (
      <div className="flex items-center gap-2">
        <a href={urlScansione(ddt.id)} target="_blank" rel="noopener noreferrer" data-testid={`archivio-apri-${ddt.id}`}
          className={`${BTN} bg-white/10 text-slate-200 hover:bg-white/20 lg:bg-gray-100 lg:text-gray-700 lg:hover:bg-gray-200`}>
          <Eye className="h-3.5 w-3.5" /> Apri
        </a>
        <a href={urlScansione(ddt.id, true)} download data-testid={`archivio-scarica-${ddt.id}`}
          className={`${BTN} bg-purple-600 text-white hover:bg-purple-700`}>
          <Download className="h-3.5 w-3.5" /> Scarica PDF
        </a>
      </div>
    );
  }
  if (ddt.stato_scansione === 'da_creare') return null;
  return (
    <>
      <input ref={input} type="file" accept="image/*,application/pdf" className="hidden" onChange={carica}
        data-testid={`archivio-file-${ddt.id}`} />
      <button type="button" onClick={() => input.current?.click()} disabled={invio} data-testid={`archivio-carica-${ddt.id}`}
        className={`${BTN} border border-amber-500/40 text-amber-300 hover:bg-amber-500/10 lg:text-amber-700 lg:border-amber-300 lg:hover:bg-amber-50 disabled:opacity-60`}>
        {invio ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}
        {invio ? 'Creo la scansione…' : 'Carica foto'}
      </button>
    </>
  );
};
